/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-radio-group[_ngcontent-%COMP%]     .mat-radio-container{-ms-grid-row-align:start;align-self:start}mat-radio-group[_ngcontent-%COMP%]     .mat-radio-label{white-space:normal}mat-radio-group[_ngcontent-%COMP%]{margin-right:10px}mat-radio-group[_ngcontent-%COMP%]   mat-error[_ngcontent-%COMP%]{font-size:13px}.mat-radio-button[_ngcontent-%COMP%]{padding-top:7px;padding-bottom:7px}.error[_ngcontent-%COMP%]{margin-top:-12px}.details[_ngcontent-%COMP%]{margin:0!important}"];
export { styles as styles };
